import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var ContactoService = /** @class */ (function () {
    function ContactoService(http) {
        this.http = http;
    }
    ContactoService.prototype.postContacto = function (contacto) {
        return this.http.post(environment.baseUrl + '/contacto/', contacto);
    };
    ContactoService.ngInjectableDef = i0.defineInjectable({ factory: function ContactoService_Factory() { return new ContactoService(i0.inject(i1.HttpClient)); }, token: ContactoService, providedIn: "root" });
    return ContactoService;
}());
export { ContactoService };
